/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Limit_1_ValueInputs */

const en_svc_integration_limit_1_value = /** @type {(inputs: Svc_Integration_Limit_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uncertain or unusual output is held for review instead of saved.`)
};

const lv_svc_integration_limit_1_value = /** @type {(inputs: Svc_Integration_Limit_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neskaidrs vai neparasts rezultāts tiek aizturēts pārbaudei, nevis saglabāts.`)
};

/**
* | output |
* | --- |
* | "Uncertain or unusual output is held for review instead of saved." |
*
* @param {Svc_Integration_Limit_1_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_limit_1_value = /** @type {((inputs?: Svc_Integration_Limit_1_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Limit_1_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_limit_1_value(inputs)
	return en_svc_integration_limit_1_value(inputs)
});